/** A closed set of choices, from an `options` list rather than from children. */

import type { Ref, SelectHTMLAttributes } from "react";

import { cn } from "@/lib/cn";

import "../internal/control.css";
import "./Select.css";

export interface SelectOption {
  readonly value: string;
  readonly label: string;
  readonly disabled?: boolean;
}

export interface SelectProps extends SelectHTMLAttributes<HTMLSelectElement> {
  readonly options: readonly SelectOption[];
  readonly invalid?: boolean;
  readonly ref?: Ref<HTMLSelectElement>;
}

export function Select({ options, invalid, className, ...rest }: SelectProps) {
  return (
    <select
      aria-invalid={invalid === true ? true : undefined}
      className={cn(
        "al-control",
        "al-select",
        invalid === true ? "al-control-invalid" : undefined,
        className,
      )}
      {...rest}
    >
      {options.map((option) => (
        <option key={option.value} value={option.value} disabled={option.disabled === true}>
          {option.label}
        </option>
      ))}
    </select>
  );
}
